import React, { Fragment } from 'react';

export default {
  title: <Fragment><strong>Petry</strong><span>-Phase</span></Fragment>,
  duration: 'Juli 2015 - April 2016',
  startDate: new Date(2015, 6, 4),
  endDate: new Date(2017, 3, 23),
  description: 'Erster Rechtsruck',
  description_long: 'Nach der Abspaltung des wirtschaftsliberalen Flügels schlägt die Partei einen deutlichen Kurs nach rechts ein. Mit der Flüchtlingskrise von 2015 hat sie im Wesentlichen ein Thema: die Migration. Merkels „Wir schaffen das“ wirkt wie ein Turbo-Antrieb für die AfD.',
  items: [{
    milestone: true,
    coords: {
      x: new Date(2015, 6, 4),
      y: 2.8
    },
    coordsMobile: {
      x: new Date(2015, 6, 4),
      y: 2.8
    },
    kicker: '4. Juli 2015',
    title: 'Petry gewinnt Duell gegen Lucke',
    text:
      <p>
        <span className="media">
          <img src="images/chronik/2-2015-07-Petry_Essen_dpa.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption">Petry als neue Chefin in Essen</span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
        </span>
        Auf dem Parteitag in Essen kommt es zum Showdown zwischen dem nationalkonservativen über den wirtschaftsliberalen Parteiflügel
        - zu einer Kampfabstimmung um den Vorsitz zwischen Frauke Petry und Bernd Lucke. Petry bekommt mit Unterstützung des rechten „Flügel“ fast zwei Drittel der Stimmen (60 Prozent), Lucke 38,1 Prozent.
        Eine Austrittswelle ist die Folge. Lucke gründet nur zwei Wochen später die Partei Allianz für Fortschritt und Aufbruch (ALFA).
        Mit der Abspaltung verliert die AfD zu dieser Zeit ein Fünftel der Mitglieder.
      </p>,
    additional: <p><strong>Erstes Umfragetief:</strong> 3 bis 5&nbsp;Prozent</p>
  }, {
    milestone: true,
    coords: {
      x: new Date(2015, 7, 31),
      y: 8.5
    },
    coordsMobile: {
      x: new Date(2015, 7, 31),
      y: 8.5
    },
    kicker: '31. August 2015',
    title: 'Merkel: „Wir schaffen das“',
    text:
      <p>
        <span className="media">
          <img src="images/chronik/1-2015-10-Merkel_Sefie_Berlin_dpa.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption">Selfie mit Geflüchteten: Merkel im September in Berlin</span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
        </span>
        „Wir haben so vieles geschafft - wir schaffen das!“, sagt Bundeskanzlerin Angela Merkel angesichts des Flüchtlingskrise vor Journalisten in Berlin. Im August kommen täglich fast 3500 Gefüchtete. Und es sollten wenig später bis zu 13.000 täglich werden.
        Als am 4. September Tausende von Ungarn über Österreich nach Deutschland unterwegs sind, entschließt sich Merkel, die Grenzen offen zu lassen und die Menschen aufzunehmen.
        Es ist ihre umstrittenste Entscheidung, die das Land spalten und für den größten Auftrieb bei der AfD sorgen wird.
      </p>
  }, {
    milestone: true,
    coords: {
      x: new Date(2016, 2, 13),
      y: 13.5
    },
    coordsMobile: {
      x: new Date(2016, 2, 13),
      y: 13.5
    },
    kicker: '13. März 2016',
    title: 'Bis dahin höchstes Ergebnis bei Landtagswahlen',
    text:
      <p>
        Die AfD erreicht als Anti-Merkel-Partei neue Höhen: Bei der Landtagswahl in Sachsen-Anhalt wählte sie jeder Vierte (24,3 Prozent). 
        Der bis dahin größte AfD-Wahlerfolg sollte die erste Kenia-Koalition (CDU, SPD, Grüne) auf Landesebene zur Folge haben.
        Doch nicht nur in den neuen Bundesländern ist die AfD im Aufwind. Am selben Tag erzielt die Partei auch im Westen zweistellige Erfolge: bei den Landtagswahlen in Baden-Württemberg (15,1 Prozent) und Rheinland-Pfalz (12,6 Prozent).
      </p>,
    additional: <p><strong>Sachsen-Anhalt-Wahl:</strong> 24,3 Prozent</p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2016, 8, 4),
      y: 13.5
    },
    coordsMobile: {
      x: new Date(2016, 8, 4),
      y: 13.5
    },
    kicker: '4. September 2016',
    title: 'Erfolge in Mecklenburg-Vorpommern und Berlin',
    text:
    <p>
       Am 4. September überspringt die AfD bei den Landtagswahlen in Mecklenburg-Vorpommern die 20-Prozent-Marke (20,8 Prozent) und wird damit hinter der SPD zweitstärkste Kraft.
       Auch bei der Berlin-Wahl - zwei Wochen später - kann die AfD mit 14,2 Prozent deutlich punkten. Das Berliner Abgeordnetenhaus ist damit das zehnte Landesparlament, in dem die Rechtspopulisten vertreten sind.
      </p>,
    additional: <p><strong>Mecklenburg-Vorpommern-Wahl:</strong> 20,8 Prozent</p>
  }, {
    coords: {
      x: new Date(2017, 0, 17),
      y: 9.5
    },
    coordsMobile: {
      x: new Date(2017, 0, 17),
      y: 9.5
    },
    title: 'Höcke: „Denkmal der Schande“',
    kicker: '17. Januar 2017',
    text:
      <p>
         Bei einer Veranstaltung der Jungen Alternative in Dresden bezeichnet Thüringens AfD-Chef Björn Höcke das Berliner Holocaust-Mahnmal als „Denkmal der Schande“
         und fordert eine „erinnerungspolitische Wende um 180 Grad“. Das sorgt international für Empörung - und führt auch parteiintern zu heftiger Kritik.
         Parteichefin Petry setzt daraufhin ein Partei-Ausschlussverfahren in Gang. Der damalige AfD-Vize Gauland nimmt Höcke dagegen in Schutz.
      </p>
  }, {
    coords: {
      x: new Date(2017, 3, 23),
      y: 7.1
    },
    coordsMobile: {
      x: new Date(2017, 3, 23),
      y: 7.1
    },
    milestone: true,
    title: 'Parteichefin Petry bei Kölner Parteitag entmachtet',
    kicker: '23. April 2017',
    text:
      <p>
        <span className="media">
          <img src="images/chronik/2-2017-Koeln_dpa.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption">Neuer Rechtsruck: Petry scheitert auf Kölner Parteitag</span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
        </span>
        Die AfD kürt beim Bundesparteitag in Köln Alice Weidel und Partei-Vize Gauland als Spitzenkandidaten zur Bundestagswahl - mit zwei Drittel der Stimmen.
        Damit ist die Entmachtung von Parteichefin Petry besiegelt.
        Sie war im Vorfeld damit gescheitert, die Partei auf einen realpolitischen Kurs einzuschwören - mit dem Ziel, mitzuregieren. Nun geht es mit ihrem Widersacher Gauland weiter nach rechts.
      </p>,
    additional: <p><strong>Zweites Umfragetief:</strong> 7 bis 10&nbsp;Prozent</p>
  }]
};